module.exports = __webpack_public_path__ + "static/03-holly-cholla-d593c0775f5ec1bf61ff857937478afb.jpg";